<template>
  <div>
    <b-modal ref="modal" title="Venda #" header-class="border-bottom-0" size="lg">
    
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">            
             <br/>
            <address v-for="row in address" :key="row.id">
              <strong>{{person.name}}</strong>
              <br />{{row.address}}, {{row.number}} 
              <br />{{row.district}} {{row.city}} {{row.state}}
              <br />{{row.zipcode}}
              <abbr title="Phone"></abbr> {{person.phone_wa}}
            </address>

            <br />
            <table class="customTable table table-hover">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Descrição</th>
                  <th>Quantidade</th>
                  <th>Valor</th>
                  <th>Total</th>
                </tr>
              </thead>
              <template>
                <tbody v-for="row in orderProducts" :key="row.id">
                  <tr>
                    <td>{{row.product_base_id}}</td>
                    <td>{{row.product}}</td>
                    <td>{{row.quantity}}</td>
                    <td>{{row.price | decimal}}</td>
                    <td>{{row.price * row.quantity | decimal}}</td>
                  </tr>
                </tbody>
              </template>
            </table>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      id:{},

      order_params: {},

     person: {},

     orderProducts:[],

     address:[]

    };
  },

  
  methods: {
    open(id) {
       this.select(id);
     
    },

     select(id) {
      this.$store.commit("showLoading");
      axios
        .get("api/order/edit/" + id)
        .then(response => {
          this.order = response.data;

          this.order_params = response.data.order;

          this.orderProducts = response.data.orderProducts;

          this.person = response.data.person;

          this.address = response.data.address;

           console.log(response.data.address);

          this.$store.commit("hideLoading");
          this.$refs.modal.show();
        })
        .catch(error => {
          
          this.$store.commit("hideLoading");
          this.error = error;
        });
    },
  }
};
</script>

<style>
</style>